import {
    type ApiResult,
    type AptosCollectionTokens,
    type BaseParams,
    type CollectionTokens,
    type CollectionTraits,
    type ContinuationResult,
    links,
    Request,
    type UnifiedCollectionFormat,
} from '@app/client';
import { apiReturnPaginatedResults } from '@app/client/apiFactory/apiReturn';

type GetCollectionTokenParams = BaseParams & {
    collectionSlug: string;
    ordering: 'token_id' | 'listing_price' | 'last_sale_price';
    direction: 'asc' | 'desc';
};

type GetCollectionTraitsParams = BaseParams & { chainSlug: UnifiedCollectionFormat };
export async function getCollectionTokens<T = AptosCollectionTokens>({
    ordering,
    direction,
    ...params
}: GetCollectionTokenParams): Promise<ApiResult<T>> {
    return Request.getRequest<T>({
        ...params,
        query: { ordering, direction, ...params.query },
        target: links.daas().v2.collection(params.collectionSlug).contents.tokens,
        apiSettingsType: 'daasV2',
    });
}

export async function getCollectionTraits({
    ...params
}: GetCollectionTraitsParams): Promise<ApiResult<CollectionTraits>> {
    return Request.getRequest<CollectionTraits>({
        ...params,
        target: links.daas().v2.collection(params.chainSlug).contents.traits,
        apiSettingsType: 'daasV2',
    });
}

export const callGetAptosCollectionToken = (params: GetCollectionTokenParams) =>
    apiReturnPaginatedResults<AptosCollectionTokens, ContinuationResult<AptosCollectionTokens>>(
        getCollectionTokens,
        params,
        true,
    );

export const callGetCollectionToken = (params: GetCollectionTokenParams) =>
    apiReturnPaginatedResults<CollectionTokens, ContinuationResult<CollectionTokens>>(
        getCollectionTokens<CollectionTokens>,
        params,
        true,
    );

export const callGetCollectionTraits = (params: GetCollectionTraitsParams) =>
    apiReturnPaginatedResults<CollectionTraits, ContinuationResult<CollectionTraits>>(
        getCollectionTraits,
        params,
        true,
    );
